/* ============================================================
   Vegannett - vn2-box-builder.js
   VN2 Box Builder (Editorial Manufaktur Redesign)

   Mechanik 1:1 portiert aus assets/box-builder.js (v3):
   - EINE Box-Variante geht via POST routes.cart_add_url in den
     Warenkorb, Sorten als Line-Item-Properties "Glas 1..N"
   - Auswahl wird zusaetzlich in cart.note gespiegelt. Grund:
     Shopify Line Item Properties werden vom Weclapp-Connector
     NICHT auf Auftragspositionen gemappt. Nur order.note wird via
     Auftragsfelder-Mapping (Notiz -> Kommentar) in Weclapp
     uebernommen. So sieht Logistik/Buchhaltung, welche Glaeser
     in der Box sind.
   - Default-Mix Preload ueber konfigurierbare Handles
   - Ausverkaufte Sorten sind disabled und werden vom Default-Fill
     uebersprungen
   - publish('cart:open') nach Erfolg (pubsub.js)

   Neu (VN2): Instanz-Init via [data-vn2-box-builder], sichtbare
   Fehler + window.vnNotify, x-Remove pro Slot, aria-live,
   Sticky-Bar via IntersectionObserver, Konfetti (max 16, WAAPI).
   Kein Abo-Stub: Kauf ist einmalig, Abo-UI liegt auf der
   Produktseite.
   ============================================================ */

(function () {
  'use strict';

  if (window.VN2BoxBuilder) {
    window.VN2BoxBuilder.init(document);
    return;
  }

  const SELECTOR = '[data-vn2-box-builder]';

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Shopify shop.money_format minimal nachgebaut, damit kein
     Waehrungsformat im JS hartkodiert ist */
  function formatMoney(cents, format) {
    const value = cents / 100;
    const map = {
      amount: value.toFixed(2),
      amount_no_decimals: String(Math.round(value)),
      amount_with_comma_separator: value.toFixed(2).replace('.', ','),
      amount_no_decimals_with_comma_separator: String(Math.round(value))
    };
    const clean = (format || '').replace(/<[^>]*>/g, '');
    if (/\{\{\s*(\w+)\s*\}\}/.test(clean)) {
      return clean.replace(/\{\{\s*(\w+)\s*\}\}/g, (m, key) => map[key] != null ? map[key] : map.amount);
    }
    return map.amount_with_comma_separator + ' €';
  }

  function createBuilder(root) {
    const configEl = root.querySelector('[data-vn2bb-config]');
    if (!configEl) return;

    let config = {};
    try {
      config = JSON.parse(configEl.textContent);
    } catch (err) {
      console.error('[VN2BoxBuilder] Config unlesbar:', err);
      return;
    }

    const SLOT_COUNT = parseInt(config.slotCount, 10) || 6;
    const BOX_PRICE = parseInt(config.boxPrice, 10) || 0;
    const money = (cents) => formatMoney(cents, config.moneyFormat);

    const els = {
      board: root.querySelector('[data-vn2bb-board]'),
      slotsWrap: root.querySelector('[data-vn2bb-slots]'),
      slots: Array.from(root.querySelectorAll('[data-vn2bb-slot]')),
      removes: Array.from(root.querySelectorAll('[data-vn2bb-slot-remove]')),
      spreads: Array.from(root.querySelectorAll('[data-vn2bb-spread]')),
      picker: root.querySelector('[data-vn2bb-picker]'),
      activeSlotLabels: Array.from(root.querySelectorAll('[data-vn2bb-active-slot]')),
      counts: Array.from(root.querySelectorAll('[data-vn2bb-count]')),
      compare: root.querySelector('[data-vn2bb-compare]'),
      compareSum: root.querySelector('[data-vn2bb-compare-sum]'),
      compareSave: root.querySelector('[data-vn2bb-compare-save]'),
      note: root.querySelector('[data-vn2bb-note]'),
      form: root.querySelector('[data-vn2bb-form]'),
      variantInput: root.querySelector('[data-vn2bb-variant]'),
      submit: root.querySelector('[data-vn2bb-submit]'),
      submitText: root.querySelector('[data-vn2bb-submit-text]'),
      reset: root.querySelector('[data-vn2bb-reset]'),
      error: root.querySelector('[data-vn2bb-error]'),
      live: root.querySelector('[data-vn2bb-live]'),
      buy: root.querySelector('[data-vn2bb-buy]'),
      bar: root.querySelector('[data-vn2bb-bar]'),
      barBtn: root.querySelector('[data-vn2bb-bar-btn]'),
      barText: root.querySelector('[data-vn2bb-bar-text]')
    };

    if (!els.slots.length || !els.form) return;

    // State: { 1: { title, handle, price, variantId, img }, 2: null, ... }
    const selections = {};
    for (let i = 1; i <= SLOT_COUNT; i++) selections[i] = null;
    let activeSlot = 1;
    // hydrated verhindert Konfetti beim Default-Preload
    let hydrated = false;
    let wasComplete = false;

    /* ---- Helpers ---- */

    function isBuyable(btn) {
      return !btn.disabled && btn.dataset.available !== 'false';
    }

    function readSpread(btn) {
      return {
        title: btn.dataset.title || '',
        handle: btn.dataset.handle || null,
        price: parseInt(btn.dataset.price || '0', 10),
        variantId: btn.dataset.variant || null,
        img: btn.dataset.img || null
      };
    }

    function nextUnfilled() {
      for (let i = 1; i <= SLOT_COUNT; i++) {
        if (!selections[i]) return i;
      }
      return null;
    }

    function filledCount() {
      return Object.values(selections).filter(Boolean).length;
    }

    function jarSum() {
      return Object.values(selections)
        .filter(Boolean)
        .reduce((sum, s) => sum + (s.price || 0), 0);
    }

    function usedHandles() {
      return Object.values(selections)
        .filter(Boolean)
        .map((s) => s.handle)
        .filter(Boolean);
    }

    function firstUnusedBuyable() {
      const used = usedHandles();
      return els.spreads.find((btn) => isBuyable(btn) && !used.includes(btn.dataset.handle)) || null;
    }

    function shorten(str) {
      // Gemeinsamen Praefix entfernen, damit Slot-Labels unterscheidbar sind
      str = (str || '')
        .replace(/^Bio Brotaufstrich\s+/i, '')
        .replace(/\s+mit .*/i, '');
      return str.length > 14 ? str.slice(0, 12) + '…' : str;
    }

    function announce(text) {
      if (els.live) els.live.textContent = text;
    }

    function showError(msg) {
      const fallback = 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.';
      const text = msg || fallback;
      if (els.error) {
        els.error.textContent = text;
        els.error.hidden = false;
      }
      if (typeof window.vnNotify === 'function') window.vnNotify(text);
    }

    function clearError() {
      if (els.error) {
        els.error.textContent = '';
        els.error.hidden = true;
      }
    }

    /* ---- Default-Mix: Preload ueber Handles (Kauf in 2 Klicks) ---- */
    // Ausverkaufte Sorten sind im Liquid disabled. Der Default-Mix darf sie
    // trotzdem nicht vorbelegen, sonst landet eine nicht lieferbare Sorte
    // ungefragt im Warenkorb.
    function applyDefaults() {
      for (let i = 1; i <= SLOT_COUNT; i++) selections[i] = null;

      const handles = (config.defaultHandles || [])
        .map((h) => String(h).trim())
        .filter(Boolean);

      if (handles.length && els.spreads.length) {
        let slot = 1;
        for (let i = 0; i < handles.length && slot <= SLOT_COUNT; i++) {
          let matched = els.spreads.find(
            (btn) => btn.dataset.handle === handles[i] && isBuyable(btn)
          ) || null;
          // Wunsch-Sorte ausverkauft oder Handle unbekannt: erste lieferbare
          // Sorte nehmen, die noch nicht in der Box liegt. Sonst bliebe der
          // Slot leer und der Kunde muesste ihn selbst fuellen.
          if (!matched) matched = firstUnusedBuyable();
          if (matched) {
            selections[slot] = readSpread(matched);
            slot++;
          }
        }
        // Weniger Handles als Slots: Rest auffuellen, damit die Box in
        // 2 Klicks kaufbar bleibt.
        while (slot <= SLOT_COUNT) {
          const fill = firstUnusedBuyable();
          if (!fill) break;
          selections[slot] = readSpread(fill);
          slot++;
        }
      }

      activeSlot = nextUnfilled() || 1;
      render();
      updateCompletion(false);
      hydrated = true;
    }

    /* ---- Interaktion ---- */

    // Bewusst KEIN scrollIntoView auf der Seite: das Slot-Band bleibt auf
    // Mobile sticky sichtbar, Scroll-Spruenge beim Fuellen waren das alte
    // UX-Problem. Hier scrollt nur das Band selbst horizontal nach, damit
    // der aktive Slot im Blick bleibt (kein Page-Jump).
    function revealActiveSlot() {
      const band = els.slotsWrap;
      if (!band || band.scrollWidth <= band.clientWidth) return;
      const btn = els.slots.find((b) => parseInt(b.dataset.vn2bbSlot, 10) === activeSlot);
      if (!btn) return;
      const wrap = btn.parentElement || btn;
      const left = wrap.offsetLeft - band.offsetLeft;
      const right = left + wrap.offsetWidth;
      if (left < band.scrollLeft || right > band.scrollLeft + band.clientWidth) {
        band.scrollTo({
          left: Math.max(0, left - band.clientWidth / 2 + wrap.offsetWidth / 2),
          behavior: reducedMotion() ? 'auto' : 'smooth'
        });
      }
    }

    function setActiveSlot(n) {
      activeSlot = n;
      render();
      revealActiveSlot();
    }

    function clearSlot(n) {
      selections[n] = null;
      activeSlot = n;
      announce('Glas ' + n + ' geleert');
      render();
      updateCompletion(false);
      revealActiveSlot();
    }

    function selectSpread(btn) {
      if (!isBuyable(btn)) return;
      const slot = activeSlot;
      selections[slot] = readSpread(btn);

      const next = nextUnfilled();
      if (next) activeSlot = next;

      const done = filledCount() === SLOT_COUNT;
      announce(
        'Glas ' + slot + ' von ' + SLOT_COUNT + ' gewählt: ' + selections[slot].title +
        (done ? '. Box vollständig.' : '')
      );

      render();
      updateCompletion(true);
      revealActiveSlot();
    }

    function checkIsDefaultMix() {
      const defaults = (config.defaultHandles || [])
        .map((h) => String(h).trim())
        .filter(Boolean);
      if (!defaults.length) return false;
      const selectedHandles = usedHandles();
      if (selectedHandles.length !== SLOT_COUNT) return false;
      const defaultSet = defaults.slice(0, SLOT_COUNT).sort().join('|');
      const selectedSet = selectedHandles.slice().sort().join('|');
      return defaultSet === selectedSet;
    }

    /* ---- Rendering ---- */

    function render() {
      const filled = filledCount();

      els.slots.forEach((btn) => {
        const n = parseInt(btn.dataset.vn2bbSlot, 10);
        const sel = selections[n];
        const isFilled = !!sel;
        const isActive = n === activeSlot;

        btn.classList.toggle('is-active', isActive);
        btn.classList.toggle('is-filled', isFilled);
        btn.setAttribute(
          'aria-label',
          isFilled ? 'Glas ' + n + ': ' + sel.title : 'Glas ' + n + ' auswählen'
        );

        const thumbEl = root.querySelector('[data-vn2bb-slot-thumb="' + n + '"]');
        if (thumbEl) {
          const currentImg = thumbEl.firstElementChild;
          if (isFilled && sel.img) {
            if (!currentImg || currentImg.getAttribute('src') !== sel.img) {
              thumbEl.textContent = '';
              const img = document.createElement('img');
              img.src = sel.img;
              img.alt = '';
              img.width = 48;
              img.height = 48;
              img.loading = 'lazy';
              thumbEl.appendChild(img);
            }
          } else {
            thumbEl.textContent = '';
          }
        }

        const nameEl = root.querySelector('[data-vn2bb-slot-name="' + n + '"]');
        if (nameEl) nameEl.textContent = isFilled ? shorten(sel.title) : '';

        const removeEl = root.querySelector('[data-vn2bb-slot-remove="' + n + '"]');
        if (removeEl) removeEl.hidden = !isFilled;
      });

      els.spreads.forEach((btn) => {
        const isSelected = !!(
          selections[activeSlot] && selections[activeSlot].variantId === btn.dataset.variant
        );
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      els.activeSlotLabels.forEach((el) => { el.textContent = activeSlot; });
      els.counts.forEach((el) => { el.textContent = filled + '/' + SLOT_COUNT; });

      // Preis-Wahrheit: der grosse Preis (Liquid, Box-Variante) wird NIE
      // angefasst. Hier nur die kleine Vergleichszeile bei voller Box.
      if (els.compare && els.compareSum && els.compareSave) {
        const sum = jarSum();
        if (filled === SLOT_COUNT && BOX_PRICE > 0 && sum > BOX_PRICE) {
          els.compareSum.textContent = money(sum);
          els.compareSave.textContent = money(sum - BOX_PRICE);
          els.compare.hidden = false;
        } else {
          els.compare.hidden = true;
        }
      }

      if (els.note) {
        const remaining = SLOT_COUNT - filled;
        els.note.textContent = remaining === 0
          ? 'Box vollständig, bereit zum Bestellen'
          : 'Noch ' + remaining + ' ' + (remaining === 1 ? 'Glas' : 'Gläser') + ' wählen';
      }

      if (els.submitText) {
        if (filled < SLOT_COUNT) {
          els.submitText.textContent = 'Box vervollständigen';
        } else {
          els.submitText.textContent = checkIsDefaultMix()
            ? 'Beliebte Auswahl in den Warenkorb'
            : 'In den Warenkorb';
        }
      }

      if (els.barText) {
        els.barText.textContent = filled === SLOT_COUNT ? 'In den Warenkorb' : 'Sorten wählen';
      }

      if (els.reset) {
        els.reset.hidden = checkIsDefaultMix() || filled === 0;
      }
    }

    function updateCompletion(celebrate) {
      const done = filledCount() === SLOT_COUNT;
      if (els.board) els.board.classList.toggle('is-complete', done);
      if (els.submit) els.submit.disabled = !done;
      if (done && !wasComplete && celebrate && hydrated && !reducedMotion()) confetti();
      wasComplete = done;
    }

    /* ---- Konfetti: max 16 Partikel, einmal pro Vervollstaendigung ---- */
    function confetti() {
      const anchor = els.board || root;
      const rect = anchor.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = Math.max(60, rect.top + rect.height / 2);
      // Farben aus den VN2-Tokens lesen, damit Konfetti der aktuellen
      // Palette (Runde 2: Lime + Ghee + Verpackungsfarben) folgt.
      const cs = getComputedStyle(document.documentElement);
      const tok = function (name, fallback) {
        const v = cs.getPropertyValue(name).trim();
        return v || fallback;
      };
      const colors = [
        tok('--vn2-lime-500', '#A9B314'),
        tok('--vn2-ghee-500', '#ECAE1B'),
        tok('--vn2-tomato-500', '#C73B2A'),
        tok('--vn2-sage-500', '#7A9E7E'),
        tok('--vn2-beet-500', '#8E2A4A')
      ];
      const count = 16;
      for (let i = 0; i < count; i++) {
        const piece = document.createElement('div');
        piece.className = 'vn2bb-confetti';
        piece.style.background = colors[i % colors.length];
        piece.style.left = cx + 'px';
        piece.style.top = cy + 'px';
        document.body.appendChild(piece);
        if (typeof piece.animate !== 'function') {
          piece.remove();
          continue;
        }
        const angle = (i / count) * Math.PI * 2;
        const dist = 70 + Math.random() * 110;
        const tx = Math.cos(angle) * dist;
        const ty = Math.sin(angle) * dist - 70;
        const rot = Math.random() * 720 - 360;
        piece.animate(
          [
            { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
            { transform: 'translate(' + tx + 'px, ' + ty + 'px) rotate(' + rot + 'deg)', opacity: 0 }
          ],
          { duration: 800, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        ).onfinish = () => piece.remove();
      }
    }

    /* ---- Submit: 1 Box-Variante + Properties, dann cart.note-Spiegel ---- */
    async function handleSubmit(e) {
      e.preventDefault();

      const allFilled = Object.values(selections).every(Boolean);
      if (!allFilled) return;

      clearError();
      const origText = els.submitText ? els.submitText.textContent : '';
      if (els.submit) {
        els.submit.disabled = true;
        if (els.submitText) els.submitText.textContent = 'Wird hinzugefügt…';
      }

      try {
        const variantId = els.variantInput ? parseInt(els.variantInput.value, 10) : 0;
        if (!variantId) throw new Error('Keine Box-Variante gefunden');

        const properties = {};
        for (let i = 1; i <= SLOT_COUNT; i++) {
          const s = selections[i];
          if (!s) throw new Error('Glas ' + i + ' ist nicht befüllt');
          properties['Glas ' + i] = s.title;
        }

        const res = await fetch(config.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: properties }] })
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || 'Cart error ' + res.status);
        }

        // Box-Auswahl zusaetzlich in cart.note spiegeln (Weclapp, siehe
        // Kommentar im Dateikopf). Best-Effort: Cart-Add war schon
        // erfolgreich, ein Fehler hier darf den Kauf nicht stoppen.
        // Gehaertet (Stufe 3): Die Note wird KOMPLETT aus den echten
        // Cart-Items neu aufgebaut statt angehaengt. Vorher blieben
        // verwaiste Box-Zeilen stehen, wenn eine Box zwischenzeitlich
        // aus dem Warenkorb entfernt wurde; das haette in Weclapp eine
        // Box gemeldet, die gar nicht in der Bestellung ist. Die Note
        // gehoert exklusiv dem Box-Spiegel (die Cart-Seite rendert
        // bewusst kein Notizfeld), Neuaufbau ist deshalb verlustfrei.
        try {
          const cartRes = await fetch(config.cartUrl || '/cart.js');
          const cart = await cartRes.json();

          const boxLines = [];
          (cart.items || []).forEach(function (item) {
            const props = item.properties || {};
            const glasKeys = Object.keys(props)
              .filter(function (k) { return /^Glas \d+$/.test(k); })
              .sort(function (a, b) {
                return parseInt(a.slice(5), 10) - parseInt(b.slice(5), 10);
              });
            if (!glasKeys.length) return;
            const parts = glasKeys.map(function (k) { return k + ': ' + props[k]; });
            for (let q = 0; q < (item.quantity || 1); q++) {
              boxLines.push('[' + item.product_title + '] ' + parts.join(' · '));
            }
          });

          await fetch(config.cartUpdateUrl || '/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: boxLines.join('\n') })
          });
        } catch (noteErr) {
          console.warn('[VN2BoxBuilder] cart.note update failed:', noteErr);
        }

        if (els.submit) {
          els.submit.disabled = false;
          if (els.submitText) els.submitText.textContent = origText;
        }
        announce('Box im Warenkorb');

        if (typeof publish === 'function') {
          publish('cart:open', {});
        } else {
          window.location.href = config.cartPageUrl || '/cart';
        }
      } catch (err) {
        console.error('[VN2BoxBuilder] Cart add failed:', err);
        if (els.submit) {
          els.submit.disabled = false;
          if (els.submitText) els.submitText.textContent = origText;
        }
        showError(err && err.message ? err.message : '');
      }
    }

    /* ---- Sticky-Bar: sichtbar solange die Section im Viewport ist und
       die Buy-Box (mit dem echten CTA) es nicht ist. IntersectionObserver
       statt Scroll-Listener: kein Layout-Thrash. CSS blendet die Bar
       ab 900px komplett aus. ---- */
    function initBar() {
      if (!els.bar || !els.buy || !('IntersectionObserver' in window)) return;

      let buyVisible = false;
      let sectionVisible = false;

      function updateBar() {
        const show = sectionVisible && !buyVisible;
        els.bar.classList.toggle('is-visible', show);
        els.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      new IntersectionObserver((entries) => {
        buyVisible = entries[0].isIntersecting;
        updateBar();
      }, { threshold: 0.2 }).observe(els.buy);

      new IntersectionObserver((entries) => {
        sectionVisible = entries[0].isIntersecting;
        updateBar();
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(root);

      if (els.barBtn) {
        els.barBtn.addEventListener('click', () => {
          if (filledCount() === SLOT_COUNT && els.submit && !els.submit.disabled) {
            if (els.form.requestSubmit) els.form.requestSubmit();
            else els.submit.click();
          } else if (els.picker) {
            // Bewusster, User-initiierter Sprung zum Sortiment; das
            // automatische Ping-Pong beim Slot-Fuellen gibt es nicht mehr.
            els.picker.scrollIntoView({
              behavior: reducedMotion() ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        });
      }
    }

    /* ---- Wiring ---- */

    els.slots.forEach((btn) => {
      btn.addEventListener('click', () => {
        const n = parseInt(btn.dataset.vn2bbSlot, 10);
        // Klick auf bereits aktiven + gefuellten Slot leert ihn (Alt-Verhalten),
        // zusaetzlich gibt es den expliziten x-Button pro Slot.
        if (n === activeSlot && selections[n]) {
          clearSlot(n);
        } else {
          setActiveSlot(n);
        }
      });
    });

    els.removes.forEach((btn) => {
      btn.addEventListener('click', () => {
        clearSlot(parseInt(btn.dataset.vn2bbSlotRemove, 10));
      });
    });

    els.spreads.forEach((btn) => {
      btn.addEventListener('click', () => selectSpread(btn));
    });

    els.form.addEventListener('submit', handleSubmit);

    if (els.reset) {
      els.reset.addEventListener('click', () => {
        activeSlot = 1;
        applyDefaults();
        announce('Beliebte Auswahl geladen');
      });
    }

    initBar();
    applyDefaults();
  }

  function initAll(scope) {
    const rootScope = scope && scope.querySelectorAll ? scope : document;
    const nodes = Array.from(rootScope.querySelectorAll(SELECTOR));
    if (rootScope !== document && rootScope.matches && rootScope.matches(SELECTOR)) {
      nodes.unshift(rootScope);
    }
    nodes.forEach((el) => {
      if (el.dataset.vn2BbReady) return;
      el.dataset.vn2BbReady = 'true';
      createBuilder(el);
    });
  }

  window.VN2BoxBuilder = { init: initAll };

  // Theme-Editor: Section wird neu gerendert, Instanz neu aufbauen.
  // theme.js beobachtet [data-reveal] nur beim ersten Load, deshalb hier
  // sofort sichtbar schalten, sonst bleiben die Elemente auf opacity 0.
  document.addEventListener('shopify:section:load', (e) => {
    const target = e.target || document;
    if (target.querySelectorAll) {
      target.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => {
        el.classList.add('is-visible');
      });
    }
    initAll(target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
})();
